module.exports = __webpack_public_path__ + "static/media/medium_painting.cd7f0112.jpg";